// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
  height: calc(100vh - 80px);
  width: 100%;
  background-size: cover;
  position: fixed;
  overflow-y: auto;
  margin-top: 80px;
}

.titleContainer {
  position: relative;
  background: white;
  padding-top: 20px;
  padding-bottom: 5px;
  margin: 0;
  text-align: center;
  width: 100%;
}

.noPadding {
  padding: 0;
}

.posts {
  position: relative !important;
  margin-top: 150px;
  padding: 50px;
  padding-bottom: 20px;
  width: 60%;
  margin-left: 40%;
  background-color: white;
  margin-bottom: 150px;
}
.posts a {
  color: #0093c5;
}
.posts h3 {
  border-bottom: 3px solid #0093c5;
  color: #0093c5;
  padding: 5px;
  padding-left: 0;
}
.posts .content {
  display: none;
  min-height: 100px;
}
.posts .content .ql-font-monospace {
  font-family: monospace !important;
}
.posts .content .ql-font-serif {
  font-family: serif !important;
}
.posts .content:first-child {
  display: block !important;
}
.posts .newsimg {
  width: 20%;
  float: right;
  padding: 10px;
}
.posts .newsimg img {
  width: 100%;
}
.posts .text {
  float: left;
  width: 100%;
}
.posts .post:nth-child(1) .content {
  display: block;
}

@media screen and (max-width: 1366px) {
  .posts {
    width: 100%;
    padding-top: 10vh;
    margin-left: 0 !important;
  }
}
twitter {
  position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/posts/posts.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,6BAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AACF;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,gCAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AADJ;AAKE;EACE,aAAA;EACA,iBAAA;AAHJ;AAKI;EACE,iCAAA;AAHN;AAMI;EACE,6BAAA;AAJN;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,UAAA;EACA,YAAA;EACA,aAAA;AATJ;AAWI;EACE,WAAA;AATN;AAaE;EACE,WAAA;EACA,WAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;;AAgBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,yBAAA;EAbF;AACF;AAiBA;EACE,eAAA;AAfF","sourcesContent":[".container-fluid {\r\n  height: calc(100vh - 80px);\r\n  width: 100%;\r\n  background-size: cover;\r\n  position: fixed;\r\n  overflow-y: auto;\r\n  margin-top: 80px;\r\n}\r\n\r\n.titleContainer {\r\n  position: relative;\r\n  background: white;\r\n  padding-top: 20px;\r\n  padding-bottom: 5px;\r\n  margin: 0;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.noPadding {\r\n  padding: 0;\r\n}\r\n\r\n.posts {\r\n  position: relative !important;\r\n  margin-top: 150px;\r\n  padding: 50px;\r\n  padding-bottom: 20px;\r\n  width: 60%;\r\n  margin-left: 40%;\r\n  background-color: white;\r\n  margin-bottom: 150px;\r\n\r\n\r\n  a {\r\n    color: #0093c5;\r\n  }\r\n\r\n  h3 {\r\n    border-bottom: 3px solid #0093c5;\r\n    color: #0093c5;\r\n    padding: 5px;\r\n    padding-left: 0;\r\n\r\n  }\r\n\r\n  .content {\r\n    display: none;\r\n    min-height: 100px;\r\n\r\n    .ql-font-monospace{\r\n      font-family: monospace !important;\r\n    }\r\n\r\n    .ql-font-serif{\r\n      font-family: serif !important;\r\n    }\r\n\r\n    \r\n  }\r\n\r\n  .content:first-child {\r\n    display: block !important;\r\n  }\r\n\r\n  .newsimg {\r\n    width: 20%;\r\n    float: right;\r\n    padding: 10px;\r\n\r\n    img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .text {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .post:nth-child(1) .content {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1366px) {\r\n  .posts {\r\n    width: 100%;\r\n    padding-top: 10vh;\r\n    margin-left: 0 !important;\r\n  }\r\n}\r\n\r\n\r\ntwitter {\r\n  position: fixed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
